// test imports
import { LIBMGR } from 'minsky-kit/js/managers/LibManager';
import WOverlay from './WOverlay';
import { renderLoader } from '../utils/loader';

// add lib to mgr
LIBMGR.add({
    tableBooker: {
        js: '//reservations.tablebooker.com/tbkr-widget-import.min.js',
    },
});

const iframeHtml = '<iframe class="reservationForm" style="width: 100%; min-width: 120px; height: 550px; border: 0;" src="//embed.tablebooker.be/33563138/nl/light?multiple_restaurants=1&amp;no_default_restaurant"></iframe>';
const defaultURL = 'https://embed.tablebooker.be/33563138/nl/ligh?multiple_restaurants=1&no_default_restaurant';

export default class BookerOverlay extends WOverlay {
    constructor (args = {}, objectName = 'BookerOverlay') {
        args.keepInDom = true;

        super(prepEl(args), objectName);

        const $content = this.$el.querySelector('.overlay__content');
        if ($content) {
            $content.appendChild(renderLoader({
                type:    'light',
                classes: [
                    'overlay__loader',
                ],
            }));
        }
    }

    refresh () {

    }

    destroy () {

    }
}

function prepEl (args) {
    // use this space to alter arguments before they are passed to the parent constructor
    // so the constructor stays clean
    args = args || {};

    const booker = document.createElement('tbkr-bm-widget');
    booker.setAttribute('restaurant-id', args.id);
    booker.setAttribute('source', 'website');
    booker.setAttribute('takeaway', '1');
    booker.setAttribute('use-modal', '0');
    booker.setAttribute('lang', document.documentElement.lang);
    booker.setAttribute('theme', 'light');
    booker.setAttribute('primary-color', '#005779');

    // generate el
    args.$el = {
        content: booker,
    };

    // return args
    return args;
}

function init () {
    // load library
    LIBMGR.load(['tableBooker'])
        .then(() => {

        })
        .catch((e) => {
            this.log('error', 'Failed to load Table booker lib', e);
        });
}
